<template>
  <div v-if="!isLoading" class="container-fluid new_Header">
    <nav class="nav_Breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('favoriteProperties.breadcrumb_1')}}</router-link></li>
        <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
        <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
        <li class="active mx-3 almarai-bold" aria-current="page">{{$t('propertiesNear_you')}}</li>
      </ol>
    </nav>
  </div>
  <div class="container pt-3">
    <div v-if="hasError">
      <errorAlert :alertMessage="message" :errorNumber='errorNumber' />
    </div>
    <div class="text-center" v-if="isLoading || dataLoading">
    <mainloader />
    </div>
    <div v-else class="row">
      <div class="col">

        <div class="row scroll-row mb-3">
          <div :class="(category == 'commercial')? 'col-auto category balck-bg':'col-auto category'">
            <label class="form-check-label mouse-hand" for="commercial">
            <input class="form-check-input" type="radio" name="radioDefault" value="commercial" 
              v-model="category" id="commercial" @change="nearProperties"
            >
              <img :src="(category == 'commercial') ?'/assets/images/icons/shop-white.png':'/assets/images/icons/shop.png'" class="max-22" alt="">
              <span class="mx-2">{{$t('commercial')}}</span>
            </label>
          </div>
          <div :class="(category == 'residential')? 'col-auto category balck-bg':'col-auto category'">
            <label class="form-check-label mouse-hand" for="resident">
            <input class="form-check-input" type="radio" name="radioDefault" value="residential" 
              v-model="category" id="resident" @change="nearProperties"
            >
              <img :src="(category == 'residential') ? '/assets/images/icons/building-white.png':'/assets/images/icons/building-4.png'" class="max-22" alt="">
              <span class="mx-2">{{$t('residential')}}</span>
            </label>
          </div>
          <div :class="(purpose == 'for_rent')? 'col-auto category balck-bg':' col-auto category'">
            <label class="form-check-label mouse-hand" for="radioDefault1">
            <input class="form-check-input" type="radio" value="for_rent" 
              v-model="purpose" name="radioDefault" id="radioDefault1" @change="nearProperties"
            >
              <span>{{$t("map.btnRent")}}</span>
            </label>
          </div>
          <div :class="(purpose == 'for_sale')? 'col-auto category balck-bg':'col-auto category'">
            <label class="form-check-label mouse-hand" for="radioDefault2">
            <input class="form-check-input" type="radio" name="radioDefault" value="for_sale" 
              v-model="purpose" id="radioDefault2" @change="nearProperties"
            >
              <span>{{$t("map.btnSale")}}</span>
            </label>
          </div>
          <!-- <div class="col-auto categoryStyle">
            <label class="form-check-label mouse-hand" @click="clearFilter()">
              <span class="mx-2">{{$t("map.btnAll")}}</span>
            </label>
          </div> -->
        </div>


        <div class="row scroll-row">
          <div class="col-auto" @click="setType(id = null)">
            <div @click="clearFilter()" :class="(fildType == null)? 'filter-buttons black-button mouse-hand':'filter-buttons mouse-hand'">
              <input class="form-check-input d-none" type="radio" name="radioDefault" :value="null" >
              <span class="almarai-bold">{{$t("map.btnAll")}}</span>
            </div>
          </div>
          <div class="col-auto mb-3 scroll-col" v-for="(row, indx) in types" :key="indx">
            <label :for="row.id">
              <div @click="setType(row.id)"
                :class="
                fildType == row.id
                  ? 'filter-buttons black-button mouse-hand'
                  : 'filter-buttons mouse-hand'
                "
              >
                <img :src="MEDIA_URL + row.icon" class="w-24" alt="" />
                <span class="mx-2">{{ row.name }}</span>
                <!-- <input type="radio" class="d-none" v-model="fildType"  :id="row.id" :value="row.id"> -->
              </div>
            </label>
          </div>
        </div>
          
        <div class="row pt-5">
          <div class="col-12 col-md-5 col-lg-3 mb-3 p-2" v-for="(val, index) in value.properties" :key="index">
            <router-link :to="'/propertydetails/' + val.id">
              <div class="card card-border m-auto">
                <div class="card-body">
                  <div class="row statusBar position-Abso pt-2">
                    <div class="col-auto tag-style">
                      <span >{{ val.PropertyType?.name }}</span>
                    </div>
                    <div class="col-auto tag-style">
                      <span>{{value.statusChoices[val.status]}}</span>
                    </div>
                    <div class="col-auto tag-style">
                      <span class="">{{(val.purpose == 'for_rent') ? $t('rent') : (val.purpose == 'for_sale') ? $t('sale')  : $t('investment') }}</span>
                    </div>
                  </div>
                  <span v-if="val.Favorites && val.Favorites.length" class="heart-icon" @click.prevent="removeFavorite(val.id, 'properties', index)">
                    <i  class="fa-solid fa-heart orange-Heart"></i>
                  </span>
                  <span v-else class="heart-icon" @click.prevent="addFavorite(val.id, 'properties', index)">
                    <i class="fa-solid fa-heart heart"></i>
                  </span>

                  <swiper v-if="val.mediaFiles.length" class="text-center"
                  :autoplay="{ delay: 2500, disableOnInteraction: false,}" :modules="modules"
                  :pagination="{ clickable: true }"
                  :navigation="false"
                  >
                  <swiper-slide v-for="(img, ind) in val.mediaFiles" :key="ind">
                    <img :src="MEDIA_URL + img.thumbnail" alt="Slide Image" class="img-fluid br-radius"/>
                  </swiper-slide>
                    </swiper>
                  <div v-else>
                    <!-- <img src="/assets/images/defaultImage.jpg" class="img-fluid br-radius" alt=""/> -->
                    <placeHolder />
                  </div>

                  <div class="text-title">{{ val.title }}</div>
                    <div class="row pt-1">
                      <div class="col-auto px-2 content-center">
                        <i class="fa-solid fa-location-dot gray-color"></i>
                      </div>
                      <div class="col p-0 fontGray-73 content-center">
                        <div class="d-flex">
                          {{ val.City?.name }}
                          <span class="mx-1">{{ val.Neighborhood?.name }}</span>
                        </div>
                      </div>
                    </div>
                    <hr class="border-color-w" />
                    <div class="row space end-card">
                      <div class="col">
                        <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                        <span class="green-color-F">{{ val.price }}</span>
                        <!-- <span class="mx-1 green-color-F">{{$t('currency')}}</span> -->
                      </div>
                      
                      <div class="col-auto content-center" v-if="val.roomsCount && val.bathrooms">
                        <div class="row">
                          <div class="col-auto content-center">
                            <span><img :src="MEDIA_URL+value.countedIcons.roomsCount.path" class="max-width-28" alt=""></span>
                            <span class="numbers">{{ val.roomsCount }}</span>
                          </div>
                          <div class="col-auto border_Icons">
                            <span><img :src="MEDIA_URL+value.countedIcons.bathrooms.path" class="max-width-28" alt=""></span>
                            <span class="numbers">{{ val.bathrooms }}</span>
                          </div>
                        </div>
                      </div>
                      <div v-else class="col-auto content-center">
                        <span><img :src="MEDIA_URL+value.countedIcons.area.path" class="max-width-28" alt=""></span>
                        <span class="numbers">{{ val.area}} <span>{{$t('areaSymbol')}}</span></span>
                      </div>
                    </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>

        <div v-if="!value.properties.length" class="row justify-content-center">
          <div class="col text-center">
            <div class="row justify-content-center">
              <div class="col-12 col-md-6 mb-3">
                <div class="card border-0 card-h">
                  <div class="card-body text-center">
                    <div><img src="/assets/images/icons/Frame_22.png" class="max-48" alt=""></div>
                    <div class="pt-2 almarai-bold font-22">
                      {{$t('home.title_7')}}
                    </div>
                    <div class="gray-color">{{$t('home.title_8')}}</div>
                    <div v-if="GET_USER" class="pt-3 m-auto w-75">
                      <router-link to="/propertyrequest">
                        <div class="btn-green">{{$t('home.title_9')}}</div>
                      </router-link>
                    </div>
                    <div v-else class="pt-3 m-auto w-50">
                      <div @click="openNearProp" class="btn-green form-control">{{$t('home.title_9')}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

          <div class="row pt-5">
            <div class="col">
                <nav aria-label="Page navigation example">
                    <ul class="pagination justify-content-center mouse-hand">
                        <li class="page-item page-link br-radius4" v-if="currentPage > 1" @click.prevent="Prevpage">
                            <i class="fa-solid fa-circle-right orange-color mx-2"></i>
                            <span>{{$t('prev')}}</span>
                        </li>
                        <li class="page-item pagination-style">{{currentPage}}</li>
                        <li class="page-item page-link br-radius4" v-if="value.properties && value.properties.length >= 30"  @click.prevent="Nextpage">
                            <span class="mx-2">{{$t('next')}}</span>
                            <i class="fa-solid fa-circle-left orange-color"></i>
                        </li>
                    </ul>
                </nav>
            </div>
          </div>
      </div>
    </div>
      <!--begin:modal login-->
      <div class="modal bg-modal" dir="rtl" tabindex="-1" id="loginNearproperties">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <div class="row">
                <div class="col">
                  <div class="row">
                    <div class="col-auto mouse-hand" @click.prevent="closeNearProp">
                      <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <div class="col text-center">
                      <div class="loginTitle">
                        {{$t("formLogin.title_1")}}
                      </div>
                      <p class="fontGray-73 mb-1 pt-1">
                        {{$t("formLogin.title_2")}} <br />
                        {{$t("formLogin.title_3")}}
                      </p>
                    </div>
                  </div>
                  <div class="row pt-3 justify-content-center">
                    <div class="col-12 col-md-8 mb-2">
                      <router-link to="/login">
                        <button class="form-control btn-green">
                          {{$t("formLogin.title_4")}}
                        </button>
                      </router-link>
                    </div>
                    <div class="col-12 col-md-8 pt-1">
                      <router-link to="/register">
                        <button class="form-control btn-black">
                          {{ $t("formLogin.title_5") }}
                        </button>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end:modal Login-->
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { mapGetters } from "vuex";
export default {
  name: "nearproperties",
  components: { Swiper, SwiperSlide },
  setup() {
    return {
    modules: [Pagination, Navigation, Autoplay]
    };
  },
  data() {
    return {
      hasError: false,
      message: "",
      errorNumber: 0,
      isLoading: true,
      latitude: this.$route.query.latitude,
      longitude: this.$route.query.longitude,
      dataLoading: true,
      types: [],
      fildType: null,
      value: {},
      currentPage: 1,
      category: "",
      userLang: 'ar',
      purpose: "",
    };
  },
  computed: {
    ...mapGetters(["MEDIA_URL", 'GET_USER']),
  },
  methods: {
    nearProperties() {
      this.hasError = false;
      this.isLoading = true;
      this.$http.get("/api/properties/nearYou?latitude="+this.latitude +"&"
      +"longitude=" +this.longitude +"&" +"typeId=" +this.fildType+'&'+'page='+this.currentPage+'&'+'category='+this.category)
      .then((res) => {
        // console.log(res);
        this.value = res.data;
        this.isLoading = false;
        })
        .catch((err) => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    getDataInit() {
      this.hasError = false;
      this.$http.get("/api/properties/init").then((res) => {
      // console.log(res);
      this.types = res.data.typesList;
      this.dataLoading = false;
      window.scroll(0, 0);
      })
      .catch((err) => {
        // console.log(err);
        this.dataLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    setType(id) {
      this.fildType = id;
      // this.nearProperties();
    },

    addFavorite(id, dataName, index){
      this.hasError = false;
      if(!this.GET_USER){
        document.getElementById('loginNearproperties').style.display = "block";
        return false;
      }
        this.$http.post("/api/favorites/add",{
          propertyId: id,
        }).then(res => {
          // console.log(res);
          if(dataName == 'properties'){
          this.value.properties[index].Favorites = [{}];
          }
        }).catch(err => {
          // console.log(err);
          [this.message, this.errorNumber] = this.$globalError(err, true);
          this.hasError = true;
        });
    },

    removeFavorite(id, dataName, index){
      this.hasError = false;
      if(!this.GET_USER){
        document.getElementById('loginNearproperties').style.display = "block";
        return false;
      }
      this.$http.delete("/api/favorites/remove/"+id).then(res => {
        // console.log(res);
        if(dataName == 'properties'){
        this.value.properties[index].Favorites = [];
        }
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    closeNearProp(){
      document.getElementById("loginNearproperties").style.display = "none";
    },

    openNearProp(){
      document.getElementById("loginNearproperties").style.display = "block";
    },

    Prevpage(){
      this.currentPage -= 1;
      this.nearProperties();
    },

    Nextpage(){
      this.currentPage += 1;
      this.nearProperties();
    },

    clearFilter(){
      this.category = "";
      this.purpose = "";
      this.fildType = null;
      this.nearProperties();
    },
  },
  created() {
    this.getDataInit();
    this.nearProperties();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
    window.scrollTo({top:0, behavior: 'smooth'});
  },
};
</script>